import RawRequest, { abortAllPendingRequests, wasRequestCancelled } from './Request';

// We not using fetch ? since when reloading or navigating away the fetch call returns a 500
// thus it's marked as error. We don't want that behavior, so we can safely handle different statuses.
// Example, reload, close or navigate away when creating products in sitefinity.
// Also, we will be using axios interceptors to refresh the token and cancel pending request

const Request = (...args) => RawRequest(...args);

let sitefinityApiPath = null;

// We cannot call this method directly, only when we're sure our component has been mounted
// Thus window object is not undefined
export function initSitefinityApiPath() {
  sitefinityApiPath = sitefinityApiPath || window.location.origin;
}

export const getSitefinityApiPath = () => sitefinityApiPath;

// ------------------------------------
// API Client
// ------------------------------------
const SitefinityApiClient = {
  get: (url) => {
    initSitefinityApiPath();
    return Request(`${sitefinityApiPath}/api/${url}`, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'include',
    });
  },
  post: (url, body) => {
    initSitefinityApiPath();
    return Request(`${sitefinityApiPath}/api/${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      data: JSON.stringify(body),
      credentials: 'include',
    });
  },
  put: (url, body) => {
    initSitefinityApiPath();
    return Request(`${sitefinityApiPath}/api/${url}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      data: JSON.stringify(body),
      credentials: 'include',
    });
  },
  delete: (url, body) => {
    initSitefinityApiPath();
    return Request(`${sitefinityApiPath}/api/${url}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      data: JSON.stringify(body),
      credentials: 'include',
    });
  },
  patch: (url, body) => {
    initSitefinityApiPath();
    return Request(`${sitefinityApiPath}/api/${url}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      data: JSON.stringify(body),
      credentials: 'include',
    });
  },
  abortAll: () => abortAllPendingRequests(),
  isCancel: (thrown) => wasRequestCancelled(thrown),
};

export default SitefinityApiClient;
